


export enum SimulationSaleStatusCode {
    SIMULATION_PENDING = 'SIMULATION_PENDING',
    SOUSCRIPTION_PENDING = 'SOUSCRIPTION_PENDING',
    SOUSCRIPTION_FINISHED = 'SOUSCRIPTION_FINISHED',
}

export const getSimulationSaleStatusCodeDescription = (simulationSaleStatusCode:SimulationSaleStatusCode) => {
    switch (simulationSaleStatusCode) {
        case SimulationSaleStatusCode.SIMULATION_PENDING:
            return 'Simulation en cours';

        case SimulationSaleStatusCode.SOUSCRIPTION_PENDING:
            return 'Souscription en cours';

        case SimulationSaleStatusCode.SOUSCRIPTION_FINISHED:
            return 'Souscription terminée';

        default:
            return undefined;
    }
}

export enum SimulationSaleStatusActionType {
    SHOW_URL = 'SHOW_URL',
    SHOW_SOUSCRIPTION_STATUS = 'SHOW_SOUSCRIPTION_STATUS',
    NONE = 'NONE'
}


export interface SimulationSaleStatusJSON {
    simulationId: string;
    souscriptionId?: string;
    actionURL?: string;
    actionType: SimulationSaleStatusActionType;
    status: SimulationSaleStatusCode;
    firstName?: string;
    lastName?: string;
    amount?: number;
    durationInMonth?: number;
    date: string; // "yyyy-MM-dd"
    nominalRate?: number;
    loanContractNumber? : string;
}


export interface SellingSouscriptionsResponseJSON {
   saleStatusItems: SimulationSaleStatusJSON[];
}
